<template>
    <div class="app--video-embed" v-if="!loading">
        <div class="overlay" v-if="overlay"></div>
        <div class="video-wrapper" v-if="provider == 'wistia'">
            <iframe :src="link" frameborder="0" allowfullscreen="" class="wistia_embed" name="wistia_embed"></iframe>
        </div>
        <div class="video-wrapper" v-if="provider == 'vimeo'">
            <iframe :src="link" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        </div>
        <div class="video-wrapper" v-if="provider == 'youtube'">
            <iframe :src="link"></iframe>
        </div>
        <div class="video-wrapper" v-if="provider == 'eMoney'">
            <div>
                <div v-if="isEditing"  :id="'video-player-'+id+'-preview'"></div>
                <div v-if="!isEditing" :id="'video-player-'+id"></div>
                <div :id="'video-player-disclaimer-part-'+id" style='position:relative'></div>
            </div>
        </div>
        <div class="video-wrapper" v-if="provider == 'loom'">
            <iframe :src="link" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        </div>
        <div class="video-wrapper" v-if="provider == 'html5'">
            <video controls>
                <source :src="src" :type="mime">
                {{$t('templates.editor.elements.video.nosupport')}}
            </video>
        </div>
    </div>
</template>

<script>
    import _each from 'lodash/each'
    import _last from 'lodash/last'

    export default {
        props: {
            overlay: {
                type: Boolean,
                default: false,
            },
            src: {
                type: String,
                default: '',
            },
            editing: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                default: 'html5',
                mime: null,
                provider: '',
                link: '',
                loading: true,
                id: '',
            };
        },
        computed: {
            isEditing() {
                return this.editing == true && document.getElementById('video-player-' + this.id) != null
            }
        },
        watch: {
            src: {
                immediate: true,
                handler() {
                    this.provider = this.default;
                    let providers = [
                        {
                            name: 'youtube',
                            regExp: /^.*(youtu.be\/|v\/|\/u\/\w\/|embed\/|watch\?)\??v?=?([^#\&\?]*).*/,
                            src: 'https://www.youtube.com/embed/',
                        },
                        {
                            name: 'wistia',
                            regExp:  /wistia.com\/medias\/([0-9a-zA-Z-_]+)/,
                            src: '//fast.wistia.net/embed/iframe/',
                        },
                        {
                            name: 'wistia',
                            regExp: /fast\.wistia\.net\/embed\/iframe\/([0-9a-zA-Z-_]+)/,
                            src: '//fast.wistia.net/embed/iframe/',
                        },
                        {
                            name: 'wistia',
                            regExp: /wistia_embed wistia_async_([0-9a-zA-Z-_]+)/,
                            src: '//fast.wistia.net/embed/iframe/',
                        },
                        {
                            name: 'vimeo',
                            regExp: /^.*((player\.)?vimeo\.com\/)((video\/)|(channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/,
                            src: 'https://player.vimeo.com/video/',
                        },
                        {
                            name: 'eMoney',
                            regExp: /abm.emaplan.com\/ABM\/MediaServe\/Embed\?token=([0-9a-zA-Z-_]+)/,
                            src: '',
                        },
                        {
                            name: 'loom',
                            regExp: /www\.loom\.com\/share\/([0-9a-zA-Z-_]+)/,
                            src: 'https://www.loom.com/embed/',
                        },
                        {
                            name: 'html5',
                            regExp: /^(https?:\/\/)?(.*).(mp4|ogg|webm)$/,
                            src: this.src,
                        }
                    ];

                    _each(providers, (provider) => {
                        let match = this.src.match(provider.regExp);
                        if (match) {
                            this.provider = provider.name;
                            this.link = provider.src + _last(match);
                            if (this.provider === 'eMoney') {
                                let matched = this.src.match(/<div id='video-player-([0-9]+)'>/)
                                this.id = _last(matched)
                            }
                            if (this.provider === 'html5') {
                                this.mime = 'video/' + _last(match);
                            }
                        }
                    });

                    if (this.provider === 'wistia') {
                        this.loadWistiaProvider().then(() => {
                            this.loading = false;
                        });
                    } else if (this.provider === 'eMoney') {
                        this.loadEmoneyProvider().then(() => {
                            let script = document.createElement('script');
                                script.src = 'https://abm.emaplan.com/ABM/MediaServe/Embed?token=' + this.link;

                            document.head.appendChild(script)
                            this.loading = false;
                            
                            if (this.isEditing) {
                                this.$nextTick(() => {
                                    if (window.player && window.jwplayer) {
                                        let cfg = window.player.getConfig()
                                        window.jwplayer('video-player-' + this.id + '-preview').setup({file: cfg.file, image: cfg.image})
                                    }
                                })
                            }
                        });
                    } else {
                        this.loading = false;
                    }
                }
            }
        },
        methods: {
            loadWistiaProvider() {
                let WistiaJS = new Promise((resolve, reject) => {
                    let script = document.createElement('script');
                    script.onload = () => {
                        resolve('import(WistiaJS)')
                    };
                    script.async = true;
                    script.src = 'https://fast.wistia.net/assets/external/E-v1.js';
                    document.head.appendChild(script)
                });

                return WistiaJS;
            },
            loadEmoneyProvider() {
                let JS = new Promise((resolve, reject) => {
                    let script = document.createElement('script');
                    script.async = true;
                    script.src = 'https://content.jwplatform.com/libraries/ljXVSIQY.js';
                    script.onload = () => { resolve('import(JS)') }
                    document.head.appendChild(script)
                });

                return JS;
            }
        }
    }
</script>
